export default {
  views: {
    privacy: {
      lastUpdated: 'Last Updated: September 10, 2026',
      companyName: 'Linktivity Inc.',
      title: 'Privacy Policy',
      personalInfoProtectionPolicy: 'Personal Information Protection Policy',
      personalInfoProtectionDescription:
        'We obtain personal information from customers on LINKTIVITY and other reservation websites that we operate. In order to allow customers to make reservations with confidence and convenience, we consider the protection of our customers’ personal information to be extremely important, and we handle personal information in compliance with the matters set out below.',
      customerDataManager: 'Controller of Your Personal Data',
      companyAddress:
        'Hibiya Park Front 19F, 2-1-6 Uchisaiwaicho, Chiyoda-ku, Tokyo 100-0011, Japan',
      acquisition: 'Acquisition',
      acquisitionDescription:
        'Where required by laws and regulations, we obtain the customer’s consent and then acquire the minimum personal information necessary to achieve our purposes of use.',
      usage: 'Use',
      usageDescription:
        'We use the personal information acquired from customers solely to achieve the purposes of use that we have established.',
      storage: 'Storage and Retention',
      storageDescription:
        'We store and retain personal information with due attention to system security so that the personal information acquired from customers is not leaked externally.',
      destruction: 'Disposal and Erasure',
      destructionDescription:
        'We dispose of personal data (meaning personal data as defined in the Act on the Protection of Personal Information; the same applies hereinafter) without delay once it is no longer necessary to use it.',
      customerInquiry: 'Responses to Customer Inquiries and Similar Matters',
      customerInquiryDescription:
        'We respond, in accordance with laws and regulations, to requests from customers for notification of the purpose of use of retained personal data (meaning retained personal data as defined in the Act on the Protection of Personal Information; the same applies hereinafter), requests for disclosure, requests for correction, addition or deletion, requests for suspension of use or erasure, and requests for suspension of provision to third parties.',
      safetyMeasures: 'Security Control Measures and Related Matters',
      safetyMeasuresDescription:
        'In addition to providing training so that all staff involved in the LINKTIVITY service understand the importance of personal information, we take the measures necessary and appropriate for the security control of personal information.',
      tableOfContents: 'Table of Contents',
      policy1: {
        title: 'Personal Information We Acquire and Purposes of Use',
        description:
          'We acquire and use personal information such as the customer’s address, name, date of birth, contact details, email address and passport number for the purposes of use listed below. We do not acquire special care-required personal information without the customer’s consent. Where the purpose of use of personal information has not been published at the time we acquire the customer’s personal information, we will notify the customer of, or publish, the purpose of use of the personal information so acquired. We also do not acquire personal information from children aged 13 or under without the consent of a parent or guardian. If personal information of a child aged 13 or under is provided to us, we will treat it as having been provided with the consent of a parent or guardian; however, if it becomes clear that no such consent was given, we will not use that personal information for any purpose other than contacting the parent or guardian and other purposes incidental thereto.',
        serviceUsage: {
          title:
            'To enable use of the LINKTIVITY service (including member registration)',
          description:
            'We share the customer’s personal information internally within our company in order to enable use of the LINKTIVITY service.',
          legalBasis:
            'Necessary in order to provide the services and functions requested by the customer.'
        },
        ticketPurchase: {
          title: 'To process applications for ticket purchases',
          infoItems:
            'When a customer applies to purchase a ticket from a product provider, we acquire the customer’s name, payment information and passport number, as well as information concerning the customer’s state of health, such as health condition and medical history.',
          purpose:
            'We acquire and use the customer’s personal information in order to confirm the customer’s eligibility to purchase tickets from the product provider and to settle payment of ticket fees and other charges. For these purposes, we also provide the customer’s personal information to product providers, transportation operators, payment settlement operators and others (including operators located overseas).',
          legalBasis:
            'Necessary in order to provide the services and functions requested by the customer.'
        },
        newsletter: {
          title:
            'To send newsletters (email magazines and the like) and other communications to customers',
          legalBasis: 'Collected based on the customer’s consent.'
        },
        advertising: {
          title:
            'For advertising through social media and advertising delivery platforms',
          legalBasis: 'Collected based on the customer’s consent.'
        },
        survey: {
          title: 'To request customers to complete surveys',
          legalBasis:
            'Collected based on the customer’s consent, for the purpose of improving our reservation website, products and services.'
        },
        analysis: {
          title: 'For the analysis and management of customer information',
          legalBasis:
            'Necessary in order to pursue and protect the legitimate interests of customers by improving our reservation website, products and services.'
        },
        fraudDetection: {
          title:
            'To detect and prevent fraudulent use of credit cards and similar payment methods',
          description1:
            'We may acquire and use the following information for the purposes of detecting and preventing fraudulent purchases, unauthorized resale, impersonation, fraudulent payment, chargebacks and other fraudulent acts in our ticket reservation service and member registration service, and of improving the safety of our services. Recipients include Forter Inc. and other fraud-prevention service providers that we publish separately.',
          description2:
            'The information we provide may include name, date of birth, email address, telephone number, address, reservation information, purchase history, payment-related information, IP address, cookie information, browser information, device information, access logs and other information necessary for the prevention of fraudulent use.',
          description3:
            'The recipients analyze this information and provide risk assessment relating to transactions, determination of fraudulent use, support for identity verification and other fraud-prevention services.',
          description4:
            'We use the analysis results and determination results provided by such operators for reservation acceptance, member registration, identity verification, payment processing, prevention of fraudulent use and service operation, and we may thereby determine whether to approve or hold a transaction or whether additional verification is required.',
          legalBasis:
            'Necessary in order to pursue the legitimate interests of our company as well as of the customer, through the prevention of fraudulent use and of fraudulent payment by credit card and similar means.'
        }
      },
      policy2: {
        title: 'Provision of Personal Data to Third Parties',
        description:
          'We do not provide personal data acquired from customers to third parties, except in any of the following cases.',
        case1:
          'Where the customer has given prior consent, by agreeing to this Privacy Policy or by other means, to the provision of personal data to third parties (including product providers, overseas travel agents, social media operators, advertising delivery service companies and other businesses)',
        case2:
          'Where the handling of personal data has been outsourced to an external party within the scope necessary to achieve the purposes of use set out above',
        case3: 'Where provision is requested pursuant to laws and regulations',
        case4:
          'Where provision is necessary for the protection of the life, body or property of a person and it is difficult to obtain the customer’s consent',
        case5:
          'Where provision is specially necessary for the improvement of public health or the promotion of the sound upbringing of children and it is difficult to obtain the customer’s consent',
        case6:
          'Where it is necessary to cooperate with a national government body, a local government or a similar entity in carrying out affairs prescribed by laws and regulations, and obtaining the customer’s consent is likely to impede the performance of such affairs'
      },
      policy3: {
        title:
          'Provision of Personal Data to Third Parties Located in Foreign Countries',
        description1:
          'As one of the cases set out in the preceding section, we may provide the customer’s personal data to third parties located in foreign countries for the purpose of detecting and preventing fraudulent transactions in the Service.',
        description2:
          'In accordance with the Act on the Protection of Personal Information and other related laws and regulations, we provide the customer with the information necessary in relation to the provision of personal data to third parties located in foreign countries, and then obtain the customer’s consent or carry out such provision on another lawful basis.',
        description3:
          'We publish or provide information concerning the personal information protection systems of the countries in which the recipients are located, the personal information protection measures taken by such third parties, and other information required to be provided under laws and regulations, by posting it on our website or by such other method as we deem appropriate.',
        description4:
          'The details of the items of data that we acquire from customers for the purpose of detecting and preventing fraudulent transactions in the Service and provide to third parties located in foreign countries are as follows.',
        item1Label: '(1) Items of personal data provided',
        item1Content:
          'Online transaction information (user ID, membership number, name, email address, telephone number, address, etc.) and device information (OS type, language, IP address, browser type, location information, device identification number, etc.)',
        item2Label: '(2) Means or method of provision',
        item2Content:
          'Electronic means (online transaction information is hashed and transmitted in an unreadable state.)',
        item3Label:
          '(3) Name of the fraud-detection service provider and of the foreign country in which it is located, etc.',
        companyNameLabel: 'Company name: ',
        companyName: 'Forter, Inc.',
        countryLabel: 'Country of location: ',
        country: 'United States',
        addressLabel: 'Address: ',
        address: '575 5th Avenue, New York, United States (10017)',
        representativeLabel: 'Representative: ',
        representative: 'Michael Reitblat',
        item4Label:
          '(4) Information concerning the systems for the protection of personal information in the foreign country',
        item4Content:
          'Please refer to the following pages on the website of the Personal Information Protection Commission.',
        item5Label:
          '(5) Measures for the protection of personal information taken by the operator of the fraud-detection service',
        item5Content:
          'Please refer to the following Forter web page (privacy policy and the like).',
        description5:
          'Where a customer has agreed to this Privacy Policy at the time of member registration or ticket purchase, we may treat the customer as having also consented to the provision of personal data to third parties located in foreign countries as set out in this section.'
      },
      policy4: {
        title: 'Outsourcing of the Handling of Personal Data',
        description:
          'Where, pursuant to the preceding section, we outsource the handling of the customer’s personal data to a third party within the scope necessary to achieve our purposes of use, we exercise necessary and appropriate supervision over the contractor. In addition, where the contractor engages a sub-contractor, we supervise, directly or indirectly, whether the contractor exercises necessary and appropriate supervision over the sub-contractor. The same applies where a sub-contractor engages a further sub-contractor.'
      },
      policy5: {
        title: 'Acquisition of Cookie Information and Similar Information',
        cookie: {
          title: 'Cookies',
          description1:
            'We may use session cookies and other cookies. A cookie is a piece of data stored on the user’s hard drive that contains information about the customer (user). We do not use cookies as information that identifies an individual. Session cookies are deleted when the browser is closed.',
          description2:
            'We use cookies for purposes such as improving the services we provide to customers, customizing our website and measuring the effectiveness of advertising.',
          description3:
            'In addition, by analyzing cookies as statistically processed data, we identify matters of high interest and concern to customers and make use of them, and we also use cookies to prevent unauthorized access.',
          description4:
            'Cookies can be disabled at the customer’s discretion; however, if they are disabled, the customer will no longer be able to make reservations on LINKTIVITY. In addition, for the purposes of preventing fraudulent use and assessing transaction risk, we may acquire cookies, device identifiers and other similar information and provide them to fraud-prevention service providers.'
        },
        logFile: {
          title: 'Log Files',
          description1:
            'We automatically collect certain information and store it in log files. Such information includes IP (Internet Protocol) addresses, browser types, ISPs (Internet Service Providers), referring/exit pages, operating systems and date/time stamps. We use this information for the purpose of monitoring unauthorized access. We also carry out analysis of customer trends, site administration and tracking of customer activity on the site.',
          description2:
            'However, we use this information in a manner that does not allow a specific individual to be identified, and we do not use the information acquired for any purpose other than those set out above. For the purposes of preventing fraudulent use and improving security, we may acquire IP addresses, browser information, device identification information, access logs and other online identifiers and provide them to fraud-prevention service providers.'
        },
        webBeacon: {
          title: 'Web Beacons',
          description:
            'We use web beacons for access analysis and for our affiliate program. We do not use web beacons for any purpose other than those set out above, nor do we use them to identify a specific individual.'
        },
        statisticalAnalysis: {
          title: 'Statistical Analysis',
          description1:
            'In order to ascertain which sites and services are most popular, we use third-party access analysis tools and record the pages that customers access within the LINKTIVITY site as well as their page history.',
          description2:
            'We use this data to provide customers who have shown an interest in a particular field with content and advertising tailored to those interests within LINKTIVITY.',
          description3:
            'We may also collect statistical information that does not identify individuals. Furthermore, we may make cookie information collected by us and cookie information collected by other companies mutually viewable on third-party access analysis tools.'
        }
      },
      policy6: {
        title: 'Handling of Anonymously Processed Information',
        creation: {
          title: 'Creation of Anonymously Processed Information',
          description1:
            'Where we create anonymously processed information, we take the measures set out below. “Anonymously processed information” means information relating to an individual that is obtained by processing personal information, through measures prescribed by laws and regulations, so that a specific individual cannot be identified, and that has been rendered incapable of restoring the original personal information.',
          description2:
            '(i) Processing the information properly in accordance with the standards prescribed by laws and regulations; (ii) taking security control measures in accordance with the standards prescribed by laws and regulations to prevent leakage of the deleted information and of information concerning the method of processing; (iii) publishing the categories of information contained in the anonymously processed information created; and (iv) refraining from any act to identify the individual to whom the personal information used for the creation relates.'
        },
        provision: {
          title: 'Provision of Anonymously Processed Information',
          description:
            'Where we provide anonymously processed information to a third party, we publish the categories of information relating to individuals contained in the anonymously processed information to be provided and the method of provision, and we expressly indicate to the recipient third party that the information being provided is anonymously processed information.'
        },
        disclosure: {
          title: 'Publication Concerning Anonymously Processed Information',
          creationSubtitle: 'Creation of anonymously processed information',
          creationDescription:
            'With respect to the following personal information of customers held by us, we continuously create anonymously processed information after taking appropriate measures to ensure that a specific individual cannot be identified and that the personal information cannot be restored.',
          itemsTitle:
            'Categories of information relating to individuals contained in the anonymously processed information',
          itemsDescription:
            'Information acquired in connection with the provision of the platform service: purchase date, participation date, voucher language, range of sales amount, number of participants, reservation status (confirmed, cancelled and the like), the supplier’s region and prefecture, and the country in which the travel agency is located',
          thirdPartyTitle:
            'Provision of anonymously processed information to third parties',
          thirdPartyDescription:
            'We continuously provide anonymously processed information created or held by us to third parties, after expressly indicating that such information is anonymously processed information.',
          provisionMethod:
            'Password-protected electronic files sent by electronic means of communication (email, upload to a server, API integration and the like) or by physical media such as DVDs'
        }
      },
      policy7: {
        title: 'Security Control Measures for Personal Data',
        description1:
          'We take organizational, technical and physical security control measures to prevent the leakage, theft, misuse, unauthorized access, alteration and destruction of personal data. Access to the servers on which we store personal data is restricted to specific employees who hold an ID and password, and for the management of certain personal data in particular, access is granted only to the minimum number of employees necessary for data management and related work.',
        description2:
          'Furthermore, personal data including credit card information is stored in a secure environment distributed across multiple data centers. We also use Secure Sockets Layer (SSL) encryption on all pages relating to reservation transactions. Through the use of an SSL-enabled browser, the confidentiality of personal data and credit card information transmitted over the Internet can be maintained.',
        description3:
          'In addition, our employees who handle customers’ personal data use password-protected screen savers when they leave their terminals.',
        description4:
          'Furthermore, we conduct educational training on the importance of personal information and related matters at a frequency of once a month in some departments and at least once every six months company-wide. We also keep records of such training.'
      },
      policy8: {
        title: 'Your Rights Regarding the Handling of Your Personal Data',
        description:
          'Under the EU General Data Protection Regulation (GDPR) 2016/679 of 27 April 2016, customers have the following rights with respect to the processing of personal data.',
        right1: 'The right of access',
        right2: 'The right to rectification',
        right3:
          'The right to erasure (the right to be forgotten) and the right to restriction of processing',
        right4: 'The right to data portability',
        right5: 'The right to object',
        right6:
          'The right not to be subject to a decision based on automated processing, including profiling.'
      },
      policy9: {
        title:
          'Requests for Disclosure, Correction, Suspension of Use and Similar Requests',
        description1:
          'We respond to requests from customers for notification of the purpose of use of retained personal data, requests for disclosure, requests for correction, addition or deletion, requests for suspension of use or erasure, and requests for suspension of provision to third parties (collectively, "Requests for Disclosure and the Like") through the contact point set out in Section 12 below.',
        description2:
          'In addition, we accommodate requests such as changing and confirming member information and unsubscribing from email magazines through the customer’s My Page.'
      },
      policy10: {
        title: 'Links to External Sites',
        description:
          'The LINKTIVITY website contains links to other sites. This Privacy Policy applies only to information collected by the LINKTIVITY website, and we bear no responsibility for the privacy policies or content of other websites. We ask customers to read the privacy policy on each linked website and to confirm how their personal information is handled there.'
      },
      policy11: {
        title: 'Changes to This Privacy Policy',
        description:
          'We post our Privacy Policy on the LINKTIVITY website so that customers can know at all times what personal information we acquire and use and for what purposes. Changes to the Privacy Policy are likewise posted on the LINKTIVITY website and thereby published to customers.'
      },
      policy12: {
        title: 'Contact Information',
        description1:
          'For questions concerning our Privacy Policy, our efforts to protect personal information, or the acquisition and use of your personal information, or for Requests for Disclosure and the Like, please use the inquiry form below. A member of our staff will respond within five business days.',
        company: 'Linktivity Inc.',
        address:
          'Hibiya Park Front 19F, 2-1-6 Uchisaiwaicho, Chiyoda-ku, Tokyo 100-0011, Japan',
        dpoContact:
          'Contact for the Data Protection Officer: dpo@linktivity.co.jp'
      },
      contentLabels: {
        acquisitionOfPersonalInfo: 'Items of personal information acquired',
        specificPurpose: 'Specific purposes of use',
        legalBasis: 'Legal basis: ',
        provisionMethod: 'Method of provision'
      }
    },
    product: {
      plans: {
        title: 'Select Plan'
      },
      cancelPolicy: {
        title: 'Cancel Policy'
      },
      recommendations: {
        title: 'Other Recommendations'
      },
      panels: {
        selectDate: 'Select Date',
        selectPlan: 'Select Plan',
        selectPeople: 'Select Number of People',
        options: 'Options',
        profile: 'Profile'
      },
      auth: {
        loginOrRegister: 'Login / Register'
      }
    },
    book: {
      title: 'Book Confirm',
      bookingNotice: 'Please check before booking',
      paymentConfirmation: 'Please check before payment',
      tip: 'To confirm your order, please complete the procedure within 15 minutes.',
      sessionInfo: 'Booking Information'
    },
    bookConfirm: {
      productInfo: 'Product Information',
      sessionConfirmed: 'Confirmed',
      sessionUnconfirmed: 'Not confirmed',
      paymentInfo: 'Payment Information',
      paymentConfirmation: {
        warningTitle: 'Please confirm the cancellation policy:',
        warningText: 'Once purchased, this product cannot be refunded.',
        agreementText: 'I have read and agree to the Terms and Conditions.'
      },
      prePaymentConfirmation: {
        title: 'Pre-payment Confirmation',
        checkInput: 'Please confirm that the entered information is correct.',
        emailNotice:
          'Note: If you have domain-specific email filtering enabled, please register "@linktivity.co.jp" before making a reservation.',
        agreementText: 'I have reviewed and agree to the above.'
      },
      paymentAmount: {
        total: 'Total Payment Amount (Including Tax)',
        details: 'Details',
        note: 'For non-JPY currencies, the displayed amount is an estimate based on the current exchange rate and may differ slightly from the actual charge. For reference only.'
      },
      confirmPaymentDialogTitle: 'Confirm payment',
      participantInfo: {
        title: 'Participant Information',
        dialogTitle: 'Edit Participant Information',
        change: 'Change',
        password: 'Password',
        validation: {
          passwordRequired: 'Please enter your password'
        }
      },
      couponApplied: 'Coupon applied successfully',
      couponFailed: 'Failed to apply coupon',
      couponRemoved: 'Coupon removed successfully',
      couponRemoveFailed: 'Failed to remove coupon',
      actionButtons: {
        back: 'Back',
        toPayment: 'To Payment'
      }
    },
    voucher: {
      pdf: 'Printable PDF',
      html: 'View Voucher'
    },
    bookingDetail: {
      title: 'Booking Details',
      detailInfo: 'Booking Details',
      startDate: 'Start Date',
      validityPeriod: 'Validity Period',
      voucherInfo: 'Voucher Information',
      digitalTicket: 'Digital Ticket',
      invoice: 'Receipt / Invoice',
      invoiceSend: 'Issue',
      invoiceSent: 'Invoice Issued',
      redemption: 'Use E-ticket',
      meetingPoint: 'Entry Location Guide',
      beforeTrip: 'Pre-use Checklist',
      bookingAction: 'Booking Actions',
      cancelBooking: 'Cancel Booking',
      cancelConfirmPolicy: 'Please confirm the cancellation policy:',
      customerName: 'Reservation Name',
      actualPayment: 'Payment Amount',
      refundAmount: 'Refund Amount',
      orderId: 'Booking ID',
      orderCompletionTime: 'Booking Time',
      digitalTicketValidPeriod: 'QR code is valid only on the day of use',
      digitalTicketWaiting:
        '*Digital ticket will be displayed here after order confirmation',
      sending: 'Sending...',
      sendToEmail: 'Send to Email',
      cancelConfirm: 'Are you sure you want to cancel the booking?',
      cancelFee: 'Cancellation Fee',
      cancelRemarkSelect: 'Please select a cancellation reason',
      inclusion: 'Included items',
      checklist: 'Checklist',
      restrictions: 'Restrictions',
      requirements: 'Requirements before and during participation',
      attireItems: 'Clothing and belongings required for participation',
      otherInfo: 'Other',
      attachmentType: {
        ATTACHMENT_TYPE_PDF: 'PDF',
        ATTACHMENT_TYPE_IMAGE: 'Image'
      }
    },
    cancelReason: {
      CANCEL_REASON_OTHER: 'Other',
      CANCEL_REASON_MODIFY_BOOKING: 'Modify booking',
      CANCEL_REASON_BOOKED_BY_MISTAKE: 'Booked by mistake',
      CANCEL_REASON_DUPLICATE_BOOKING: 'Duplicate booking',
      CANCEL_REASON_HEALTH_CONDITION: 'Illness',
      CANCEL_REASON_TRANSPORTATION_ISSUE: 'Transportation issue',
      CANCEL_REASON_SCHEDULE_CONFLICT: 'Schedule conflict',
      CANCEL_REASON_CHANGE_TO_OTHER_PRODUCT: 'Change to other product'
    },
    common: {
      withDashSeparated: '{{val1}} - {{val2}}'
    },
    home: {
      title: 'SHIBUYA SKY',
      header: {
        alt: 'SHIBUYA SKY'
      },
      search: {
        placeholder: 'Search products'
      },
      ticketList: {
        title: 'Ticket List'
      },
      enjoyPack: {
        title: 'Enjoy Pack'
      }
    },
    faq: {
      tips: `For inquiries regarding the information provided in this FAQ, including online purchases, cancellations, and receipt issuance, please contact LINKTIVITY Customer Support.
For inquiries regarding SHIBUYA SKY facilities and services, please contact SHIBUYA SKY through the inquiry page on the official SHIBUYA SKY website.
https://www.shibuya-scramble-square.com/sky/contact/

LINKTIVITY Customer Support
Email: <a href="mailto:helpcenter@linktivity.co.jp" rel="noreferrer">helpcenter@linktivity.co.jp</a>
Phone number for online purchase inquiries: <a href="tel:+81368217193">03-6821-7193</a>
※When you call, you will first be guided by an automated voice system and then connected to an operator depending on the nature of your inquiry.
※Call charges apply.
Operator support hours: 10:00–19:00`
    }
  }
};
